import { render } from "./ProchainEvents.vue?vue&type=template&id=66e7b610"
import script from "./ProchainEvents.vue?vue&type=script&lang=js"
export * from "./ProchainEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__